<template lang="pug">
.v-leasing-form
	form(@submit.prevent="send")
		h2.sf-heading-1 Mennyi lesz a lízingdíjam?
		.dropdown-field.dropdown-field--arrow.dropdown-field--lease-type-settings
			.dropdown-field-container
				.form-row
					.form-col
						.label-tooltip-wrapper
							label#vl-debtorType-lbl(for="vl-debtorType") Lízing igénylő
							VueTooltip(placement="bottom")
								p(slot="content")
									| Fogyasztók részére a kalkulátor kizárólag a zártvégű pénzügyi lízingfinanszírozásra kiterjedően érhető el.
									br
									| Őstermelőként az egyéni vállalkozó kategóriát válassza.
									br
									| Cég kategóriába tartozik: gazdálkodó és egyéb szervezetek pl.: ügyvédi iroda, polgármesteri hivatal, nonprofit kht, alapítvány, egyház stb.
					.form-col
						VueSelect#vl-debtorType(:max-width="224", label-id="vl-debtorType-lbl", v-model="model.debtorType", placeholder="Válassz")
							VueSelectOption(v-for="(item, index) in debtorType", :value="item.key", :text="item.value", :index="index", :label-id="`vl-debtorType-li-${index}`", :key="item.key")
				.form-row
					.form-col
						label#vl-vehicleDesignation-lbl(for="vl-vehicleDesignation") Gépjármű típusa
					.form-col
						VueSelect#vl-vehicleDesignation(:max-width="224", label-id="vl-vehicleDesignation-lbl", v-model="model.vehicleDesignation", placeholder="Válassz")
							VueSelectOption(v-for="(item, index) in vehicleDesignation", :value="item.key", :text="item.value", :index="index", label-id="label1", :key="item.key")
				.form-row(v-if="enterpriseLeasingVehicleDesignationLorry && hasMoreTypes")
					.form-col
						.label-tooltip-wrapper
							label#vl-financeType-lbl(for="vl-financeType") Finanszírozás típusa
							VueTooltip(placement="bottom")
								p(slot="content")
									| Normál finanszírozás esetén a Merkantil Bank saját termékeivel nyújt finanszírozást.
									br
									br
									| A kedvezményes évi 2,5% kamatozású #[strong Széchényi Lízing GO!] esetén a KAVOSZ Zrt. által működtetett Széchényi Kártya Program keretében történik az ügylet finanszírozása.
									br
									br
									| Széchényi Lízing GO! finanszírozást kizárólag KKV-nak minősülő társas vállalkozások, egyéni cégek, egyéni vállalkozók, őstermelők, ŐCSG-k, szövetkezetek és egyéb gazdasági tevékenységet folytató jogalanyok vehetik igénybe.
					.form-col
						VueSelect#vl-financeType(:max-width="224", label-id="vl-financeType-lbl", v-model="model.financeType", placeholder="Válassz")
							VueSelectOption(v-for="(item, index) in financeType", :value="item.key", :text="item.value", :index="index", label-id="label1", :key="item.key")
			svg.dropdown-arrow(width="32", height="16", viewbox="0 0 32 16", fill="none", xmlns="http://www.w3.org/2000/svg", aria-hidden="true")
				path(fill-rule="evenodd", clip-rule="evenodd", d="M13.6286 1.96444C13.8848 0.850958 14.8574 0 16 0C17.1426 0 18.1152 0.85096 18.3714 1.96444C19.3548 6.23822 22.6268 16 32 16H0C9.37315 16 12.6452 6.23822 13.6286 1.96444Z", fill="#FFFFFF")

		VehicleLeasingFormVehicleData(:model="model", :isEnterprise="isEnterprise", :vehicleUsed="vehicleUsed", :vehicleSource="vehicleSource", :insuranceType="insuranceType", :insuranceOwnContribution="insuranceOwnContribution", :vehicleManufacturerToDesignation="manufacturer", :isVehichleDesignationLorry="VEHICLE_DESIGNATION_LORRY", :vehicleAgeLimit="vehicleAgeLimit", :insuranceIncluded="insuranceIncluded", :finance-types="financeType")
		VehicleLeasingFormLeasingData(
			:model="model",
			:debtorType="model.debtorType",
			:leasingType="leasingType",
			:finance-types="financeType",
			:personalLeasing="personalLeasing",
			:enterpriseLeasing="enterpriseLeasing",
			:openEnterpriseLeasing="openEnterpriseLeasing",
			:closedEnterpriseLeasing="closedEnterpriseLeasing",
			:minFinancedPrice="minFinancedPrice",
			:maxFinancedPrice="maxFinancedPrice",
			:minOwnContribution="minOwnContribution",
			:vehicleAgeEndOfFinancingLimit="vehicleAgeEndOfFinancingLimit",
			:vehicleSourceImport="vehicleSourceImport",
			:financedPrice="financedPrice",
			:periodNumber="periodNumber",
			:ownContributionPercents="ownContributionPercents"
		)
		.form-row(v-if="captchaImg", :class="{ 'has-error': ($v.model.captchaText.$dirty && $v.model.captchaText.$invalid) || captchaError }")
			.form-col
				label#vl-captcha-label(for="vl-captcha-input") Írja be a képen látható kódot
			.form-col
				VueCaptcha#vl-captcha-input(:img="'data:image/png;base64,' + captchaImg", v-model="model.captchaText", :max-width="104", @keyup="$emit('captcha-keyup')", @blur="$v.model.captchaText.$touch()", :has-error="($v.model.captchaText.$dirty && $v.model.captchaText.$invalid) || (!$v.model.captchaText.$dirty && captchaError)", aria-describedby="vl-captcha-error")
				VueErrorMessage#vl-captcha-error(v-if="$v.model.captchaText.$dirty && !$v.model.captchaText.required", position="bottom") Kérjük, adja meg a képen látható kódot!
				VueErrorMessage#vl-captcha-error(v-if="!$v.model.captchaText.$dirty && captchaError", position="bottom") Kérjük, ellenőrizze a képen látható kódot!

		.form-row.form-row--submit-button
			vue-button(ref="button", type="submit", :disabled="sending") Kiszámítom a lízingdíjam
		.gif-loader(v-if="loading")
			img.gif-loader__image(src="../../../assets/img/components/loader/loader.gif")
		.v-leasing-form__notification-container
			VueFormNotification(v-if="resultState === RESULTSTATES.CALCULATION_ERROR && !loading")
				P(slot="title") Hoppá!
				| A kalkuláció során hiba történt, kérjük próbálja meg újra!
		VehicleLeasingFormResult(v-if="resultState === RESULTSTATES.SUCCESS && !loading", :calculations="calculations", :periodNumber="periodNumber", :resultInitTabIndex="resultInitTabIndex", :finance-types="financeType")
		div(v-if="resultState === RESULTSTATES.SUCCESS")
			slot(name="disclaimer-text")
			template(v-if="personalLeasing")
				slot(name="personal-info")
			template(v-if="enterpriseLeasing")
				slot(name="enterprise-info")
</template>

<script>
import VehicleLeasingFormVehicleData from './vehicle-leasing-form-vehicle-data/vehicle-leasing-form-vehicle-data';
import VehicleLeasingFormLeasingData from './vehicle-leasing-form-leasing-data/vehicle-leasing-form-leasing-data';
import VehicleLeasingFormResult from './vehicle-leasing-form-result/vehicle-leasing-form-result';
import { VueSelect, VueSelectOption } from '@ui-common/vue-select';
import VueTooltip from '@ui-common/vue-tooltip';
import VueButton from '@ui-common/vue-button';
import VueCheckbox from '@ui-common/vue-checkbox';
import VueCaptcha from '@ui-common/vue-captcha';
import VueFormNotification from '@ui-common/vue-form-notification';
import VueErrorMessage from '@ui-common/vue-error-message';
import { jumpToFirstError } from '../../../common/js/find-first-error-component/find-first-error-component';
import { errorHandlerUtils } from '../../../common/js/utils/error-handler-utils';
import { required, minLength, numeric, between, minValue, maxValue } from 'vuelidate/lib/validators';
import { FORMATTING_CONSTANTS } from '@ui-common/sf-js-utils';
import {
	VEHICLE_DESIGNATION,
	DEBTOR_TYPES,
	LEASING_TYPE,
	RESULTSTATES,
	VEHICLE_AGE_LIMIT,
	VEHICLE_AGE_END_OF_FINANCING_LIMIT,
	INSURANCE_TYPE,
	MIN_DEBTOR_AGE,
	MIN_OWN_CONTRIBUTION_RATE,
	MIN_FINANCED_PRICE,
	MAX_FINANCED_PRICE,
	INSURANCE_OWN_CONTRIBUTION_DEFAULT,
	REST_AMOUNT_MIN_MAX,
	VEHICLE_SOURCE
} from '../constants';
import moment from 'moment';
const DEFAULT_PERIOD_NUMBER = '48';
export default {
	mixins: [jumpToFirstError, errorHandlerUtils],
	data: () => ({
		technicalError: false,
		model: {
			restAmountPercent: null,
			debtorType: null,
			vehicleDesignation: null,
			financeType: null,
			vehicleUsed: 'Y',
			vehicleSource: '1',
			dateOfManufacture: null,
			insuranceType: '2',
			performance: null,
			insuranceOwnContribution: INSURANCE_OWN_CONTRIBUTION_DEFAULT,
			manufacturer: null,
			debtorAge: null,
			zipCode: null,
			netSellPrice: null,
			leasingType: null,
			grossSellPrice: null,
			ownContribution: null,
			vat: null,
			registrationTax: null,
			periodNumber: DEFAULT_PERIOD_NUMBER,
			acceptPrivacyStatement: false,
			captchaText: null
		},
		calculationDebtorType: null
	}),
	props: {
		defaultDebtorType: {
			required: false
		},
		defaultVehicleDesignation: {
			required: true
		},
		debtorType: {
			required: true
		},
		vehicleDesignation: {
			required: true
		},
		vehicleUsed: {
			required: true
		},
		vehicleSource: {
			required: true
		},
		insuranceType: {
			required: true
		},
		insuranceOwnRisk: {
			required: true
		},
		leasingType: {
			required: true
		},
		personalPeriodNumber: {
			required: true
		},
		enterprisePeriodNumber: {
			required: true
		},
		vehicleManufacturerToDesignation: {
			required: true
		},
		insuranceOwnContribution: {
			required: true
		},
		calculations: {
			type: Object
		},
		resultState: {
			type: String
		},
		captchaImg: {
			required: true
		},
		captchaError: {
			required: true
		},
		loading: {
			type: Boolean,
			required: true
		},
		resultInitTabIndex: {
			type: Number,
			required: true
		},
		financeType: {
			required: true
		},
		sending: {
			required: true
		}
	},
	provide() {
		return {
			$v: this.$v,
			hasFormError: this.hasFormError,
			validateField: this.validateField
		};
	},
	validations() {
		return {
			financedPrice: {
				minValue: minValue(this.minFinancedPrice),
				maxValue: maxValue(this.maxFinancedPrice)
			},
			ageOfVehicleEndOfFinancing: {
				maxValue: maxValue(this.vehicleAgeEndOfFinancingLimit)
			},
			model: {
				restAmountPercent: this.openEnterpriseLeasing
					? {
							required
					  }
					: {},
				performance: this.insuranceIncluded
					? {
							required,
							numeric
					  }
					: {},
				dateOfManufacture: {
					required,
					minLength: minLength(7),
					isBefore: val => moment(val, FORMATTING_CONSTANTS.DISPLAY_DATE[this.$i18n.locale]).isBefore(moment()),
					vehicleAgeNotSupported: () => this.ageOfVehicle < this.vehicleAgeLimit
				},
				manufacturer: this.insuranceIncluded
					? {
							required
					  }
					: {},
				debtorAge:
					this.insuranceIncluded && !this.isEnterprise
						? {
								required,
								minValue: minValue(MIN_DEBTOR_AGE)
						  }
						: {},
				leasingType: !this.personalLeasing
					? {
							required
					  }
					: {},
				zipCode: this.insuranceIncluded
					? {
							required,
							numeric
					  }
					: {},
				grossSellPrice: {
					required
				},
				netSellPrice: this.openEnterpriseLeasing
					? {
							required
					  }
					: {},
				vat: this.openEnterpriseLeasing
					? {
							required
					  }
					: {},
				registrationTax:
					this.openEnterpriseLeasing &&
					(this.model.vehicleUsed == 'Y' || (this.model.vehicleUsed == 'N' && this.model.vehicleSource == VEHICLE_SOURCE.HOME))
						? {
								required,
								numeric
						  }
						: {},
				ownContribution: {
					required,
					between: between(this.minOwnContribution, this.model.grossSellPrice)
				},
				captchaText: this.captchaImg
					? {
							required
					  }
					: {}
			}
		};
	},
	components: {
		VehicleLeasingFormVehicleData,
		VehicleLeasingFormLeasingData,
		VehicleLeasingFormResult,
		VueSelect,
		VueSelectOption,
		VueTooltip,
		VueButton,
		VueCheckbox,
		VueCaptcha,
		VueErrorMessage,
		VueFormNotification
	},
	methods: {
		focusButton() {
			this.$refs.button.$refs.button.focus();
		},
		send() {
			this.$v.$touch();
			if (this.$v.$invalid) {
				this.jumpToFirstError();
			} else {
				let financeType = this.model.financeType ? this.model.financeType : this.financeType[0].key;
				this.$store.dispatch('calculation-email/setDebtorType', this.model.debtorType);
				this.$store.dispatch('calculation-email/setFinanceType', financeType);
				this.focusButton();
				this.$emit('submit', {
					model: this.model,
					type: {
						personalLeasing: this.personalLeasing,
						includedInsurance: this.insuranceIncluded,
						openEnterpriseLeasing: this.openEnterpriseLeasing,
						closedEnterpriseLeasing: this.closedEnterpriseLeasing
					}
				});
			}
		},
		resetCaptcha() {
			this.model.captchaText = null;
			this.$v.model.captchaText.$reset();
		}
	},
	watch: {
		'model.financeType'(val) {
			this.model.periodNumber = DEFAULT_PERIOD_NUMBER;
			if (val == this.financeType[1]?.key) {
				this.model.insuranceType = this.insuranceType[1].key;
			}
		},
		'model.leasingType'() {
			this.model.periodNumber = DEFAULT_PERIOD_NUMBER;
		},
		enterpriseLeasing(val) {
			if (val) {
				this.model.financeType = this.financeType[0].key;
			} else {
				this.model.financeType = null;
			}
		},
		openEnterpriseLeasing(val) {
			if (val) {
				if (this.model.vehicleSource == VEHICLE_SOURCE.HOME) {
					if (this.model.vehicleUsed == 'Y') {
						this.model.registrationTax = 0;
						this.model.grossSellPrice = null;
					} else {
						this.model.grossSellPrice = null;
						this.model.registrationTax = null;
					}
				} else {
					this.model.vehicleUsed = 'Y';
					this.model.registrationTax = null;
				}
			} else {
				this.model.registrationTax = null;
			}
		},
		openEnterpriseLeasing(val) {
			this.$v.model.restAmountPercent.$reset();
			if (val) {
				if (this.model.vehicleSource == VEHICLE_SOURCE.HOME) {
					if (this.model.vehicleUsed == 'Y') {
						this.model.registrationTax = 0;
					} else {
						this.model.registrationTax = null;
					}
				} else {
					this.model.vehicleUsed = 'Y';
					this.model.registrationTax = null;
				}
			} else {
				this.model.registrationTax = null;
			}
		},
		'model.debtorType'(val) {
			if (val == DEBTOR_TYPES.PERSONAL) {
				this.model.leasingType = null;
			} else if (!this.model.leasingType) {
				this.model.leasingType = LEASING_TYPE.CLOSED;
			}
		},
		captchaError(val) {
			if (val) {
				this.$nextTick(() => {
					this.jumpToFirstError();
				});
			}
		},
		modelWithoutCaptcha() {
			this.$emit('form-changed');
		}
	},
	computed: {
		isSzechenyi() {
			return this.model.financeType == this.financeType?.[1]?.key;
		},
		isLorry() {
			return this.model.vehicleDesignation == VEHICLE_DESIGNATION.LORRY;
		},
		ownContributionPercents() {
			return this.isLorry && this.closedEnterpriseLeasing && this.isSzechenyi
				? [
						{ key: 29.13, value: '29,13' },
						{ key: 30, value: '30' },
						{ key: 40, value: '40' },
						{ key: 50, value: '50' }
				  ]
				: [
						{ key: 20, value: '20' },
						{ key: 30, value: '30' },
						{ key: 40, value: '40' },
						{ key: 50, value: '50' }
				  ];
		},
		isEnterprise() {
			return this.model.debtorType == DEBTOR_TYPES.ENTERPRISE;
		},
		modelWithoutCaptcha() {
			const newModel = Object.assign({}, this.model);
			delete newModel.captchaText;
			return JSON.stringify(newModel);
		},
		minRestAmount() {
			const ltSixMillion = this.model.grossSellPrice < 12000000;
			return (
				this.model.grossSellPrice *
				(ltSixMillion ? REST_AMOUNT_MIN_MAX.LT_TWELVE_MILLION : REST_AMOUNT_MIN_MAX.GE_TWELVE_MILLION)[this.model.periodNumber].MIN
			);
		},
		maxRestAmount() {
			const ltSixMillion = this.model.grossSellPrice < 12000000;
			return (
				this.model.grossSellPrice *
				(ltSixMillion ? REST_AMOUNT_MIN_MAX.LT_TWELVE_MILLION : REST_AMOUNT_MIN_MAX.GE_TWELVE_MILLION)[this.model.periodNumber].MAX
			);
		},
		minFinancedPrice() {
			return this.model.vehicleUsed == 'Y' ? MIN_FINANCED_PRICE.OLD : MIN_FINANCED_PRICE.NEW;
		},
		maxFinancedPrice() {
			return this.model.vehicleUsed == 'Y' ? MAX_FINANCED_PRICE.OLD : MAX_FINANCED_PRICE.NEW;
		},
		minOwnContribution() {
			const minOwnContributionRate = this.ownContributionPercents[0].key / 100;
			if (this.personalLeasing || !this.openEnterpriseLeasing) {
				return Math.ceil(this.model.grossSellPrice * minOwnContributionRate);
			} else {
				return Math.ceil((this.model.netSellPrice + this.model.registrationTax) * minOwnContributionRate);
			}
		},
		periodNumber() {
			return this.enterprisePeriodNumber && this.enterpriseLeasing ? this.enterprisePeriodNumber[this.model.financeType] : this.personalPeriodNumber;
		},
		manufacturer() {
			return this.vehicleManufacturerToDesignation && this.vehicleManufacturerToDesignation[this.model.vehicleDesignation];
		},
		personalLeasing() {
			return this.model.debtorType === DEBTOR_TYPES.PERSONAL;
		},
		enterpriseLeasing() {
			return this.model.debtorType === DEBTOR_TYPES.ENTERPRISE || this.model.debtorType === DEBTOR_TYPES.SELF_EMPLOYED;
		},
		closedEnterpriseLeasing() {
			return this.enterpriseLeasing && this.model.leasingType === LEASING_TYPE.CLOSED;
		},
		openEnterpriseLeasing() {
			return this.enterpriseLeasing && this.model.leasingType === LEASING_TYPE.OPEN;
		},
		enterpriseLeasingVehicleDesignationLorry() {
			return this.enterpriseLeasing && this.VEHICLE_DESIGNATION_LORRY;
		},
		hasMoreTypes() {
			return this.financeType.length > 1;
		},
		ageOfVehicle() {
			return moment().diff(moment(this.model.dateOfManufacture, FORMATTING_CONSTANTS.DISPLAY_DATE[this.$i18n.locale]), 'years');
		},
		vehicleAgeLimit() {
			return this.VEHICLE_DESIGNATION_CAR || this.VEHICLE_DESIGNATION_TRUCK || this.VEHICLE_DESIGNATION_BIKE
				? VEHICLE_AGE_LIMIT.PERSONAL
				: VEHICLE_AGE_LIMIT.ENTERPRISE;
		},
		vehicleAgeEndOfFinancingLimit() {
			return this.VEHICLE_DESIGNATION_CAR || this.VEHICLE_DESIGNATION_TRUCK || this.VEHICLE_DESIGNATION_BIKE
				? VEHICLE_AGE_END_OF_FINANCING_LIMIT.PERSONAL
				: VEHICLE_AGE_END_OF_FINANCING_LIMIT.ENTERPRISE;
		},
		ageOfVehicleEndOfFinancing() {
			const dateEndOfFinancing = moment()
				.add(this.model.periodNumber, 'months')
				.startOf('day');
			return dateEndOfFinancing.diff(
				moment(this.model.dateOfManufacture, FORMATTING_CONSTANTS.DISPLAY_DATE[this.$i18n.locale]).startOf('day'),
				'years',
				true
			);
		},
		VEHICLE_DESIGNATION_LORRY() {
			return this.model.vehicleDesignation === VEHICLE_DESIGNATION.LORRY;
		},
		VEHICLE_DESIGNATION_CAR() {
			return this.model.vehicleDesignation === VEHICLE_DESIGNATION.CAR;
		},
		VEHICLE_DESIGNATION_BIKE() {
			return this.model.vehicleDesignation === VEHICLE_DESIGNATION.BIKE;
		},
		VEHICLE_DESIGNATION_TRUCK() {
			return this.model.vehicleDesignation === VEHICLE_DESIGNATION.TRUCK;
		},
		insuranceIncluded() {
			return this.model.insuranceType === INSURANCE_TYPE.INCLUDED;
		},
		RESULTSTATES() {
			return RESULTSTATES;
		},
		financedPrice() {
			if (this.personalLeasing || !this.openEnterpriseLeasing) {
				return this.model.grossSellPrice - this.model.ownContribution;
			} else {
				return this.model.netSellPrice + this.model.registrationTax - this.model.ownContribution;
			}
		},
		vehicleSourceImport() {
			return this.model.vehicleSource == VEHICLE_SOURCE.IMPORT;
		}
	},
	created() {
		this.model.debtorType = this.defaultDebtorType;
		this.model.vehicleDesignation = this.defaultVehicleDesignation;
	}
};
</script>

<style lang="scss">
@import '@ui-common/sf-style-utils/lib/helpers/_colors.scss';
@import '@ui-common/sf-style-utils/lib/helpers/_queries.scss';

.v-leasing-form *[class^='sf-heading'] {
	padding-left: 24px;
	padding-right: 24px;

	@include media('>=tablet') {
		padding-left: 60px;
		padding-right: 60px;
	}

	@include media('>=desktop') {
		padding-left: 84px;
		padding-right: 84px;
	}

	@include media('>=desktop-lg') {
		padding-left: 96px;
		padding-right: 96px;
	}
}

.v-leasing-form .sf-heading-1 {
	margin: 0 0 32px;

	@include media('>=tablet') {
		font-size: 30px;
		font-weight: 700;
		line-height: 34px;
	}
}

.v-leasing-form .mxsl *[class^='sf-heading'] {
	margin-left: 0;
	margin-right: 0;
	padding-left: 0;
	padding-right: 0;
}

.v-leasing-form .dropdown-field--arrow .dropdown-arrow:last-child {
	bottom: 0;
	left: calc(50% - 16px);
	top: auto;

	@include media('>=tablet') {
		left: 336px;
	}

	@include media('>=desktop') {
		left: 466px;
	}

	@include media('>=desktop-lg') {
		left: 476px;
	}
}

.v-leasing-form .dropdown-field--arrow.dropdown-field--lease-type-settings {
	@include media('>=tablet') {
		margin-bottom: 64px;
	}
}

.v-leasing-form .form-row--submit-button {
	@include media('>=tablet') {
		margin-bottom: 0;
	}
}

.v-leasing-form .sf-btn {
	@include media('>=tablet') {
		margin-bottom: 28px;
	}
}

.v-leasing-form .sf-text-fineprint {
	@include media('>=tablet') {
		margin-bottom: 48px;
	}
}

.vehicle-leasing-form__disclaimer-text {
	@include media('<tablet') {
		margin-top: 24px;
		padding: 0 24px;
	}
}

.v-leasing-form .v-leasing-form__notification-container {
	margin: 0 24px;

	@include media('>=tablet') {
		margin: 0 60px;
	}

	@include media('>=desktop') {
		margin: 0 84px;
	}

	@include media('>=desktop-lg') {
		margin: 0 96px;
	}
}

.v-leasing-form ::v-deep .sf-select__button-wrapper::before {
	pointer-events: none;
}
</style>
